// @flow

import * as React from 'react';
import PropTypes from 'prop-types';

import List from '@mui/material/List';

const Container = ({ children, ...restProps }) => (
  <List dense {...restProps}>
    {children}
  </List>
);

Container.propTypes = {
  children: PropTypes.array.isRequired
};

export default Container;